import '../css/T&C.css'

function TermsConditions() {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>Terms & Conditions</h1>
        <p>Last Updated: June 2026</p>
      </div>

      <div className="terms-content">

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing this website, enrolling in our courses, or using our
            services, you agree to comply with these Terms & Conditions.
          </p>
        </section>

        <section>
          <h2>2. Use of Website</h2>
          <ul>
            <li>Use the website only for lawful purposes.</li>
            <li>Provide accurate registration information.</li>
            <li>Do not attempt unauthorized access to our systems.</li>
            <li>Do not copy or distribute website content without permission.</li>
          </ul>
        </section>

        <section>
          <h2>3. Course Enrollment</h2>
          <ul>
            <li>Enrollment is subject to seat availability.</li>
            <li>Course schedules may change when necessary.</li>
            <li>Admission may be canceled if false information is provided.</li>
          </ul>
        </section>

        <section>
          <h2>4. Fees & Payments</h2>
          <p>
            Course fees must be paid according to the payment schedule.
            Failure to pay fees may result in suspension or cancellation.
          </p>
        </section>

        <section>
          <h2>5. Refund Policy</h2>
          <p>
            Refund requests must be submitted in writing. Refund eligibility
            depends on the specific course policy.
          </p>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            All content including text, images, logos, graphics, videos,
            and course materials are the property of the institute and
            protected by copyright laws.
          </p>
        </section>

        <section>
          <h2>7. Student Conduct</h2>
          <ul>
            <li>Maintain professional behavior.</li>
            <li>Respect trainers and fellow students.</li>
            <li>Avoid harassment or disruptive conduct.</li>
          </ul>
        </section>

        <section>
          <h2>8. Certificates</h2>
          <p>
            Certificates will be issued after successful completion of the
            course and fulfillment of attendance requirements.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            The institute shall not be liable for indirect damages,
            website interruptions, or employment outcomes.
          </p>
        </section>

        <section>
          <h2>10. External Links</h2>
          <p>
            Our website may contain links to third-party websites. We are
            not responsible for their content or policies.
          </p>
        </section>

        <section>
          <h2>11. Privacy</h2>
          <p>
            Your use of this website is also governed by our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>12. Modifications</h2>
          <p>
            We reserve the right to update these Terms & Conditions at any
            time without prior notice.
          </p>
        </section>

        <section>
          <h2>13. Governing Law</h2>
          <p>
            These Terms & Conditions are governed by the laws of India.
          </p>
        </section>

        <section>
          <h2>14. Contact Us</h2>
          <p>Email: contact@amplemind.in</p>
          <p>Phone: +91 9552211561</p>
          <p>Address: 08, Near Zudio, Gurudev Nagar, Nagpur</p>
        </section>

      </div>
    </div>
  );
}

export default TermsConditions;